import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DocuTypeService } from "../../model/backoffice/document-type";
import { BranchDocuService } from "../../model/backoffice/docubranch";
import { FieldName2Lower, GetEditorForm } from "../../core/Helper2";
import CheckList from "../../core/CheckList";
import { AlertOK } from "../../core/Helper";

export default function DocuBranchEditor(props) {
  const userInfo = useSelector((state) => state.user.detail);
  const [form, setForm] = useState();
  const [editor, setEditor] = props.editor;
  const [view, setView] = useState();
  const [component, setComponent] = useState({
    allItems: [],
    oldItems: [],
    BrchID: editor.idValue,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (editor?.show) {
      loadDocu();
    }
    return () => {
      setComponent([]);
      setView(null);
    };
  }, [editor?.show]);

  const loadDocu = async (text) => {
    let dca = await DocuTypeService.GetList({ text: text ?? "" }, userInfo);
    let dcb = await BranchDocuService.GetList(
      {
        text: text,
        //root: [FieldName2Lower(editor?.idFieldName)] + "=" + editor?.idValue,
        root: "brchid=" + editor?.idValue,
      },
      userInfo
    );

    setComponent((pv) => ({
      ...pv,
      allItems: dca ?? [],
      oldItems: dcb ?? [],
      BrchID: editor.idValue,
    }));
  };

  useEffect(() => {
    setView(
      <CheckList
        {...{
          data: [component, setComponent],
          listIdname: "DocuTypeId",
          resultIdname: "DocuBrchId",
        }}
      />
    );
  }, [component]);

  useEffect(() => {
    setForm(view);
  }, [view]);

  const actionSave = async () => {
    let result = await BranchDocuService.SaveItem(
      { ...component, brchid: editor.idValue },
      userInfo
    );

    if (result) {
      AlertOK("บันทึกสมบูรณ์", dispatch);
      setEditor((pv) => ({ ...pv, show: false }));
    }
  };
  return (
    <GetEditorForm
      {...{
        title: `เอกสารสำหรับ ${editor?.rowData?.BrchShort}`,
        editor: [editor, setEditor],
        form: [form, setForm],
        saveData: actionSave,
      }}
    ></GetEditorForm>
  );
}
